"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEASURE_PATH = exports.LABEL_PATH = void 0;
exports.LABEL_PATH = 'labels';
exports.MEASURE_PATH = 'measures';
